var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/useAtomicPromise.ts
import { Mutex as Mutex2 } from "async-mutex";

// src/usePromise.ts
import { Mutex } from "async-mutex";
import { useEffect, useMemo, useState } from "react";

// src/context/context.ts
import { createContext } from "react";
var defaultPromiseSettings = {
  logErrors: true
};
var PromiseSettingsContext = createContext(defaultPromiseSettings);

// src/context/hook.ts
import { use } from "react";
var usePromiseSettings = /* @__PURE__ */ __name(() => {
  return use(PromiseSettingsContext);
}, "usePromiseSettings");

// src/usePromise.ts
var usePromise = /* @__PURE__ */ __name((promise, dependencies, config) => {
  const { logErrors = true } = usePromiseSettings();
  const [result, setResult] = useState(config?.defaultValue);
  const [error, setError] = useState();
  const [state, setState] = useState("pending");
  const mutex = useMemo(() => {
    return new Mutex();
  }, []);
  if (config?.debug) console.log(`usePromise [${config?.debug}]: started [${typeof promise}]`);
  const promiseMemo = useMemo(() => {
    try {
      if (config?.debug) console.log(`usePromise [${config?.debug}]: re-memo [${typeof promise}]`);
      setState("pending");
      return promise?.();
    } catch (ex) {
      const error2 = ex;
      if (logErrors) {
        console.error(`usePromise-memo: ${error2}`);
        globalThis?.rollbar?.error(error2);
      }
      if (config?.debug) console.log(`usePromise [${config?.debug}]: useMemo rejection [${typeof promise}]`);
      setResult(void 0);
      setError(error2);
      setState("rejected");
    }
  }, dependencies);
  if (config?.debug) console.log(`usePromise [${config?.debug}] Main Function`);
  useEffect(() => {
    let loaded = true;
    if (config?.debug) console.log(`usePromise [${config?.debug}] useEffect`);
    mutex?.acquire().then(() => {
      promiseMemo?.then((payload) => {
        if (config?.debug) console.log(`usePromise [${config?.debug}] then`);
        if (loaded) {
          setResult(payload);
          setError(void 0);
          setState("resolved");
        }
        mutex?.release();
      }).catch((e) => {
        const error2 = e;
        if (logErrors) {
          console.error(error2);
          globalThis?.rollbar?.error(error2);
        }
        if (loaded) {
          setResult(void 0);
          setError(error2);
          setState("resolved");
        }
        mutex?.release();
      });
    }).catch((ex) => {
      const error2 = ex;
      if (logErrors) {
        console.error(`usePromise-memo: ${error2}`);
        globalThis?.rollbar?.error(error2);
      }
      if (loaded) {
        setResult(void 0);
        setError(error2);
        setState("rejected");
      }
      mutex?.release();
    });
    return () => {
      loaded = false;
      if (config?.debug) console.log(`usePromise [${config?.debug}] useEffect callback`);
    };
  }, [
    ...dependencies,
    promiseMemo
  ]);
  if (config?.debug) console.log(`usePromise [${config?.debug}] returning ${JSON.stringify([
    result,
    error,
    state
  ], null, 2)}`);
  return [
    result,
    error,
    state
  ];
}, "usePromise");

// src/useAtomicPromise.ts
var mutexDictionary = {};
var useAtomicPromise = /* @__PURE__ */ __name((name, promise, dependencies, config) => {
  mutexDictionary[name] = mutexDictionary[name] ?? new Mutex2();
  return usePromise(() => mutexDictionary[name].runExclusive(promise), dependencies, config);
}, "useAtomicPromise");
export {
  useAtomicPromise,
  usePromise
};
//# sourceMappingURL=index.mjs.map